export default __webpack_public_path__ + "static/media/免责声明.5c16e2bd.pdf";